import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./components/header";
import Homepage from "./components/home_page";
import Footer from "./components/footer";





class App extends Component {

  state = {
    dialog:{
      status:false, 
      msg:""
    }
  };





  render() {
    


    return (
      <div>
      <Router>
        <Switch>
        <Route
            exact
            path="/"
            render={(props) => (
              <Homepage/>
            )}
          />
        </Switch>
      </Router>
      <Footer/>
      </div>
    );

    
  }
}

export default App;
